import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { TradesDcParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { TradesDcReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { TradesDcReportGridData } from '@pages/reporting-pages/deliveries-trades-dc/types/TradesDcReportGridData';
import { convertToGridData } from '@pages/reporting-pages/deliveries-trades-dc/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingDeliveriesTradesDcState {
	gridData: TradesDcReportGridData[] | null,
	dateRange: DateRange | null,
};

const initialState: ReportingDeliveriesTradesDcState = {
	gridData: null,
	dateRange: null,
};



export const reportingDeliveriesTradesDcSlice = createSlice({
	name: 'reportingDeliveriesTradesDc',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<TradesDcReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<TradesDcParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setSearchParameters,
	resetStore } = reportingDeliveriesTradesDcSlice.actions;